(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bb-awards"] && !Shopify.designMode) return;
  try {
    if (!window.bbAwardsReady) {
window.bbAwardsReady = true;
document.addEventListener('click', function (event) {
var button = event.target.closest('[data-bb-awards-scroll]');
if (!button) return;
var track = button.parentElement.querySelector('[data-bb-awards-track]');
if (!track) return;
var direction = parseInt(button.getAttribute('data-bb-awards-scroll'), 10) || 1;
track.scrollBy({ left: direction * track.clientWidth * 0.75, behavior: 'smooth' });
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bb-review-quote"] && !Shopify.designMode) return;
  try {
    if (!window.bbRqReady) {
    window.bbRqReady = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bb-rq-more]');
      if (!button) return;
      var card = button.closest('[data-bb-rq]');
      card.classList.toggle('is-open');
      button.textContent = card.classList.contains('is-open') ? 'show less' : 'show more';
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bb-trust-row"] && !Shopify.designMode) return;
  try {
    if (!window.bbDialogsReady) {
    window.bbDialogsReady = true;
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-bb-dialog-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-bb-dialog-open'));
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }
      if (event.target.closest('[data-bb-dialog-close]')) {
        var open = event.target.closest('dialog');
        if (open) open.close();
        return;
      }
      if (event.target.classList && event.target.classList.contains('bb-dialog')) event.target.close();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
